<p class="dialog-subtitle">{{ 'feedback.subtitle' | translate }}</p>

<div class="feedback-form">
  <textarea
    pTextarea
    [ngModel]="feedbackText()"
    (ngModelChange)="feedbackText.set($event)"
    [rows]="8"
    [maxlength]="maxLength"
    [placeholder]="'feedback.placeholder' | translate"
    [disabled]="sending()"
    class="feedback-textarea">
  </textarea>

  <!-- The ceiling, said as the member nears it — the one counter home. -->
  <app-char-counter class="feedback-counter" [left]="remainingChars()"/>
</div>

<div class="feedback-actions">
  <button
    pButton
    type="button"
    class="p-button-primary"
    (click)="sendFeedback()"
    [disabled]="!isValid() || sending()">
    <fa-duotone-icon [icon]="sending() ? faSpinnerThird : faPaperPlane" [class.fa-spin]="sending()"></fa-duotone-icon>
    {{ (sending() ? 'feedback.sending' : 'feedback.send') | translate }}
  </button>
</div>

<!-- The discard prompt's mount on this component's own confirm instance (see the class note). -->
<p-confirmDialog styleClass="discard-confirm" />
